export const getUserName = (amsUserName?: string, orgUserName?: string): string | undefined => {
  const isNameDifferent = amsUserName !== orgUserName;

  if (amsUserName && orgUserName && isNameDifferent) {
    return orgUserName;
  }

  return amsUserName || orgUserName || undefined;
};
